import { useState } from 'react';

import Button from 'honeydew/Button';
import Modal from 'honeydew/Modal';
import useInAssortmentPreview from 'hooks/useInAssortmentPreview';

function PricingDisclaimer() {
    const [disclaimerModal, setDisclaimerModal] = useState(false);
    const { inAssortmentPreview } = useInAssortmentPreview();

    return (
        <>
            <p className="text-body-xs mt-20 md:mt-auto">
                *Click{' '}
                <Button className="link cursor-pointer" onClick={() => setDisclaimerModal(true)}>
                    here
                </Button>{' '}
                to learn more about how we calculate these prices and savings
            </p>
            <Modal open={disclaimerModal} onClose={() => setDisclaimerModal(false)} headline="Our pricing" centered>
                {inAssortmentPreview ? (
                    <p>
                        Our stated price reflects the average price of this product across all locations for the current
                        week. We calculate our savings by comparing our price (excluding tax, shipping, and fees) to
                        that of various grocery stores and online retailers, as well as the product&apos;s
                        manufacturer&apos;s suggested retail price (MSRP), if applicable. Actual price and savings may
                        vary from week to week based on your delivery location and other factors. Products subject to
                        availability.
                    </p>
                ) : (
                    <p>
                        *Our stated price reflects the average price of this product across all locations in 2023. We
                        calculate our savings by comparing our price (excluding tax, shipping, and fees) to that of
                        various grocery stores and online retailers, as well as the product&apos;s manufacturer&apos;s
                        suggested retail price (MSRP), if applicable. Actual pricing and savings may vary.
                    </p>
                )}
            </Modal>
        </>
    );
}

export default PricingDisclaimer;
